"use client";

import { useState } from "react";
import { useTranslations } from "@i18n/provider";
import type { OverlayMessage } from "../types";
import { ConversationTranscript } from "./ConversationTranscript";

type TranscriptAccordionProps = {
  messages: OverlayMessage[];
  defaultCollapsed?: boolean;
};

export function TranscriptAccordion({
  messages,
  defaultCollapsed = true,
}: TranscriptAccordionProps) {
  const { t } = useTranslations();
  const [expanded, setExpanded] = useState(!defaultCollapsed);
  const panelId = "debrief-transcript-panel";

  return (
    <div className="mb-3">
      <button
        type="button"
        aria-expanded={expanded}
        aria-controls={panelId}
        onClick={() => setExpanded((prev) => !prev)}
        className="flex min-h-[44px] w-full items-center justify-between rounded-xl px-2 text-sm font-semibold text-ink"
      >
        {expanded
          ? t("agent.conversation.debrief.hideTranscript")
          : t("agent.conversation.debrief.showTranscript")}
        <span className="material-symbols-outlined text-lg" aria-hidden="true">
          {expanded ? "expand_less" : "expand_more"}
        </span>
      </button>
      {expanded ? (
        <div
          id={panelId}
          className="mt-1 max-h-[120px] overflow-y-auto rounded-2xl bg-surface-sunk p-2"
          style={{ boxShadow: "var(--inset-field)" }}
        >
          <ConversationTranscript messages={messages} />
        </div>
      ) : null}
    </div>
  );
}
